import React from 'react'
import { Route } from 'react-router-dom'

function RouteWrapper(props) {
  return <Route {...props} />
}

export default RouteWrapper
